// Menu Firework Effect - Für Silvester/Neujahr
import React from 'react';

export function MenuFireworkEffect() {
  const [fireworks, setFireworks] = React.useState([]);
  const fireworkIdRef = React.useRef(0);
  
  React.useEffect(() => {
    const colors = ['#ff0040', '#ffcc00', '#00ff88', '#00ccff', '#ff00ff', '#ffffff', '#ff6600', '#00ffcc'];
    
    const createFirework = () => {
      const count = 1 + Math.floor(Math.random() * 3);
      const newFireworks = [];
      
      for (let i = 0; i < count; i++) {
        const sparkCount = 10 + Math.floor(Math.random() * 8);
        const color = colors[Math.floor(Math.random() * colors.length)];
        const sparks = [];
        
        for (let s = 0; s < sparkCount; s++) {
          const angle = (s / sparkCount) * 360;
          const distance = 25 + Math.random() * 45;
          const rad = angle * (Math.PI / 180);
          sparks.push({
            x: Math.cos(rad) * distance,
            y: Math.sin(rad) * distance + 20,
            delay: Math.random() * 0.3
          });
        }
        
        newFireworks.push({
          id: fireworkIdRef.current++,
          left: 10 + Math.random() * 80,
          top: 20 + Math.random() * 60,
          color: color,
          sparks: sparks,
          scale: 0.6 + Math.random() * 0.6
        });
      }
      
      setFireworks(newFireworks);
      setTimeout(() => setFireworks([]), 2000);
    };
    
    createFirework();
    const interval = setInterval(() => {
      createFirework();
    }, 2000 + Math.random() * 2000);
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <div className="menu-fireworks-container">
      {fireworks.map(fw => (
        <div 
          key={fw.id}
          className="menu-firework-explosion"
          style={{
            left: `${fw.left}%`,
            top: `${fw.top}px`,
            transform: `scale(${fw.scale})`
          }}
        >
          {fw.sparks.map((spark, idx) => (
            <div
              key={idx}
              className="menu-firework-spark"
              style={{
                background: fw.color,
                boxShadow: `0 0 6px ${fw.color}, 0 0 12px ${fw.color}`,
                '--spark-x': `${spark.x}px`,
                '--spark-y': `${spark.y}px`,
                animationDelay: `${spark.delay}s`
              }}
            />
          ))}
          <div 
            className="menu-firework-center"
            style={{ background: fw.color, boxShadow: `0 0 15px ${fw.color}, 0 0 30px ${fw.color}` }}
          />
        </div>
      ))}
    </div>
  );
}
